export default __webpack_public_path__ + "static/media/photo_gallery_12.9c194edc.png";